import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * EntNose icon
 *
 * @category Medical
 */
const EntNose = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <g clip-path="url(#ent-nose-a)">
          <path
            fill="currentColor"
            d="M22.714 18.65c-.99-1.282-1.259-2.983-1.468-4.603-.443-3.262-.886-6.525-1.34-9.787-.047-.373-.117-.758-.362-1.038-.244-.28-.433.052-.433.43 0 .534 1.49 13.662 2.04 16.915.059.315.29.893.524 1.103.623.561.747-.095.852-.387.059-.175 0-.373.07-.536.152-.303.606-.198.897-.011 1.096.699 1.923 2.062 1.48 3.285-.151.408-.454.781-.874.874-.42.094-.92-.186-.955-.617-.012-.198.058-.408-.047-.571-.116-.187-.407-.187-.594-.058-.186.128-.07.873-.174 1.07-1.107 2.156-3.614 3.4-6.038 3.423s-4.962-1.29-6.104-3.422c-.128-.245-.163-.92-.396-1.071-.233-.152-.606-.14-.723.104-.105.21.012.478-.035.7-.058.268-.35.442-.63.43-.279-.01-.523-.174-.698-.384-.513-.594-.536-1.503-.222-2.214.315-.71.92-1.258 1.562-1.712.14-.105.314-.199.49-.164.465.105.256.944.652 1.2.221.14.536.035.699-.174.163-.21.21-.478.256-.734.92-5.453 1.294-10.988 2.226-16.441.058-.373.367-1.296 0-1.259-.583.058-.874 1.154-.979 1.596-.268 1.13-.431 2.273-.583 3.426-.29 2.168-.594 4.323-.827 6.502-.151 1.41-.315 2.901-1.2 3.997-.71.874-1.783 1.375-2.587 2.167-.652.652-1.118 1.526-1.165 2.447-.047.92.35 1.888 1.119 2.412.547.373 1.211.513 1.852.71 1.818.595 3.356 1.842 5.185 2.413 1.527.477 3.228.442 4.72-.152 1.41-.57 2.61-1.608 4.043-2.12.804-.292 1.701-.408 2.389-.921 1.06-.792 1.328-2.4.71-3.577-.699-1.328-2.225-1.993-3.192-3.146a1 1 0 0 0-.117-.14z"
          />
        </g>
        <defs>
          <clipPath id="ent-nose-a">
            <path fill="currentColor" d="M0 0h32v32H0z" />
          </clipPath>
        </defs>
      </svg>
    );
  }
);

EntNose.displayName = 'EntNose';

export { EntNose };
